import ServiceError from '../domain/ServiceError.js';

class EmailAddressValidator {

  constructor(validatorUtils) {

    this.validatorUtils = validatorUtils;

  }

  validate(emailAddress) {

    if (!this.validatorUtils.emailAddressIsValid(emailAddress)) {
      throw new ServiceError(400, {
        error_code: 90003,
        field_messages: [
          {
            field: 'email_address',
            error_code: 90113
          }
        ]
      });
    }

  }
  
}

export default EmailAddressValidator;



// WEBPACK FOOTER //
// ./src/library/validators/EmailAddressValidator.js